import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ShapeTriangleIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="shapeTriangle" ref={ref} {...props}>
    <path d="M21.33,20.75H3.22a.75.75,0,0,1-.65-1.12l9.06-16a.75.75,0,0,1,.65-.38h0a.75.75,0,0,1,.65.38l9.05,16a.75.75,0,0,1-.65,1.12ZM4.51,19.25H20.05L12.28,5.52Z" />
  </Icon>
)) as IconWithRender;

ShapeTriangleIcon.displayName = 'ShapeTriangleIcon';
ShapeTriangleIcon.renderIcon = (props) => <ShapeTriangleIcon {...props} />;
export default ShapeTriangleIcon;
